import PropTypes from 'prop-types';
import React from 'react';
import Relay from 'react-relay/classic';
import { Link, withRouter } from 'react-router';
import Loader from 'components/widgets/Loader';
import TransactionList from 'components/widgets/TransactionList';
import { showProfileZapcash } from '../helpers/domainSettings';
import { Comatose } from 'components/helpers/utils';
import UpdateProfilePictureMutation from 'mutations/UpdateProfilePictureMutation';
import '../styles/dashboard.less';

class Dashboard extends React.Component {
  static propTypes = {
    relay: PropTypes.shape({
      forceFetch: PropTypes.func,
    }).isRequired,
    viewer: PropTypes.shape({
      zapperId: PropTypes.string,
      auth: PropTypes.shape({
        email: PropTypes.string,
      }),
      profile: PropTypes.shape({
        id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        birthday: PropTypes.string,
        gender: PropTypes.string,
        streetAddress: PropTypes.string,
        locationId: PropTypes.string,
        image: PropTypes.string,
      }),
      zapCashCurrencyBalance: PropTypes.shape({
        name: PropTypes.string,
        redeemable: PropTypes.number,
      }),
      currencyBalances: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              id: PropTypes.string,
              name: PropTypes.string,
              image: PropTypes.string,
              acceptingBranchesCount: PropTypes.number,
              pendingEarn: PropTypes.number,
              redeemable: PropTypes.number,
              rawId: PropTypes.string,
            }),
          })
        ),
      }),
      transactions: PropTypes.shape({
        edges: PropTypes.arrayOf(
          PropTypes.shape({
            node: PropTypes.shape({
              id: PropTypes.string,
              rawId: PropTypes.string,
              merchant: PropTypes.shape({
                name: PropTypes.string,
              }),
              branch: PropTypes.shape({
                name: PropTypes.string,
              }),
              status: PropTypes.string,
              amount: PropTypes.number,
              transactedAt: PropTypes.number,
              allotments: PropTypes.arrayOf(
                PropTypes.shape({
                  currency: PropTypes.shape({
                    rawId: PropTypes.string.isRequired,
                    name: PropTypes.string,
                  }).isRequired,
                  earnAmount: PropTypes.number.isRequired,
                  redeemAmount: PropTypes.number.isRequired,
                })
              ),
            }),
          })
        ),
      }),
    }).isRequired,
  };

  state = {
    updating: false,
  };

  componentWillMount() {
    const { viewer, router } = this.props;
    let zapperId = viewer ? viewer.zapperId : null;
    if (!zapperId) {
      router.replace('/login');
    } else if (zapperId && !this.isCompleteProfile()) {
      router.replace('/profile');
    }
  }

  onPictureSuccess(s) {
    this.setState({ updating: false });
    console.log('MUTATION SUCCESS', s);
  }

  onPictureFailure(e) {
    this.setState({ updating: false });
    console.log('MUTATION FAILED', e);
  }

  getImage = () => {
    //e.target.value.length > 0 - checks if cancelled or not
    this.setState({ updating: true });

    let onSuccess = (s) => {
      this.onPictureSuccess(s);
    };
    let onFailure = (e) => {
      this.onPictureFailure(e);
    };

    let mutation = new UpdateProfilePictureMutation({
      profile: this.props.viewer.profile,
      file: this.refs.profilePic.files.item(0),
    });
    Relay.Store.commitUpdate(mutation, { onSuccess, onFailure });
  };

  isCompleteProfile() {
    let viewer = this.props.viewer;
    let profile = viewer.profile;
    let email = viewer.auth ? viewer.auth.email : viewer.auth;
    if (
      email &&
      profile.firstName &&
      profile.lastName &&
      profile.birthday &&
      profile.gender &&
      profile.locationId
    ) {
      return true;
    }
    return false;
  }

  renderBalance(b, index) {
    return (
      <div key={index} className='currency-value'>
        <div className='currency'>{b.node.name}</div>
        <div className='value'>{Comatose(b.node.redeemable)}</div>
      </div>
    );
  }

  render() {
    let profile = { ...this.props.viewer.profile };
    let zapCashBalanceName = this.props.viewer.zapCashCurrencyBalance.name;
    let zapCashBalanceValue =
      this.props.viewer.zapCashCurrencyBalance.redeemable;
    let currencyBalances = this.props.viewer.currencyBalances.edges;
    let image = (
      <div className='profile-pic'>
        <input
          className='image-picker'
          type='file'
          ref='profilePic'
          onChange={this.getImage}
          accept='image/*'
        />
        <img className='avatar' src={profile.image} />
      </div>
    );
    if (this.state.updating) {
      image = (
        <div className='image-loader'>
          <Loader loading />
        </div>
      );
    }

    return (
      <div id='dashboard'>
        <div className='offwhite-bg' />
        <div className='banner-container'>
          <div className='banner'>
            <div className='section'>
              {image}
              <div className='details'>
                <div className='full-name'>
                  {`${profile.firstName} ${profile.lastName}`}
                </div>
                <Link className='link' to='/profile'>
                  Go to My profile
                </Link>
              </div>
            </div>
            <div className='section wallet'>
              <div className='details'>
                {showProfileZapcash() ? (
                  <div className='zapcash currency-value'>
                    <div className='currency'>{zapCashBalanceName}</div>
                    <div className='value'>{Comatose(zapCashBalanceValue)}</div>
                  </div>
                ) : null}

                {currencyBalances.map((b, index) =>
                  this.renderBalance(b, index)
                )}

                <Link className='link' to='/wallet'>
                  See more
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className='body-container'>
          <div className='section-border'>
            <div className='section-title'>Recent Transactions</div>
          </div>
          <TransactionList
            transactions={this.props.viewer.transactions}
            seeMore
          />
        </div>
      </div>
    );
  }
}

export default Relay.createContainer(withRouter(Dashboard), {
  initialVariables: {
    currencyBalancesCount: 3,
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        zapperId,
        auth {
          email,
        },
        profile {
          id,
          firstName,
          lastName,
          birthday,
          gender,
          locationId,
          image(size: "140x140")
        },
        zapCashCurrencyBalance {
          name,
          redeemable
        },
        currencyBalances(isZapCashIncluded: false, first: $currencyBalancesCount) {
          edges {
            node {
              name,
              redeemable
            }
          }
        },
        transactions(first: 5) {
          edges {
            node {
              id,
              rawId,
              merchant {
                name
              },
              branch {
                name
              },
              status,
              amount,
              transactedAt,
              pointsAllotments {
                currency {
                  rawId,
                  name
                },
                earnAmount,
                redeemAmount
              },
              couponAllotments {
                couponId,
                promotionName,
                earn,
                redeem
              },
              type
            }
          }
        }
      }`,
  },
});



// WEBPACK FOOTER //
// ./js/components/pages/Dashboard.js